export const cluster = (size = "small") => {
  if (size === "medium") {
    return `
      <svg width="575.625" height="575.625" viewBox="0 0 152.301 152.301" xmlns="http://www.w3.org/2000/svg">
        <rect style="fill:#36c;fill-opacity:.22352941;stroke-width:4.75939846" width="152.301" height="152.301" rx="76.15"/>
        <g transform="matrix(6.18422 0 0 6.18422 -47.009 -47.534)" style="fill:#36c">
          <rect style="fill:#36c" x="12" y="12" width="16" height="16" rx="8"/>
          <rect style="fill:#36c;stroke:#fff;stroke-width:1.44874513;stroke-miterlimit:4;stroke-dasharray:none" x="10.278" y="10.278" width="19.445" height="19.445" rx="9.722"/>
        </g>
      </svg>
    `;
  } else if (size === "large") {
    return `
      <svg width="575.625" height="575.625" viewBox="0 0 152.301 152.301" xmlns="http://www.w3.org/2000/svg">
        <rect style="fill:#039;fill-opacity:.22352941;stroke-width:4.75939846" width="152.301" height="152.301" rx="76.15"/>
        <g transform="matrix(6.18422 0 0 6.18422 -47.009 -47.534)" style="fill:#039">
          <rect style="fill:#039" x="12" y="12" width="16" height="16" rx="8"/>
          <rect style="fill:#039;stroke:#fff;stroke-width:1.44874513;stroke-miterlimit:4;stroke-dasharray:none" x="10.278" y="10.278" width="19.445" height="19.445" rx="9.722"/>
        </g>
      </svg>
    `;
  } else {
    return `
      <svg width="575.625" height="575.625" viewBox="0 0 152.301 152.301"  xmlns="http://www.w3.org/2000/svg">
       <rect width="152.301" height="152.301" rx="76.15" fill="#69f" fill-opacity=".224"/>
       <g transform="translate(-47.01 -47.53) scale(6.1842)">
        <rect x="12" y="12" width="16" height="16" rx="8" fill="#5f6368"/>
        <rect x="10.278" y="10.278" width="19.445" height="19.445" rx="9.723" fill="#69f" stroke="#fff" stroke-width="1.449"/>
       </g>
      </svg>
    `;
  }
};

export const unscheduledStop = () => {
  return `
    <svg width="38" height="38" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="32" height="32" rx="16" fill="#202124" fill-opacity=".2"/>
      <g filter="url(#a)">
        <rect x="12" y="12" width="16" height="16" rx="8" fill="#5F6368"/>
        <rect x="13" y="13" width="14" height="14" rx="7" stroke="#fff" stroke-width="2"/>
      </g>
      <defs>
        <filter id="a" x="0" y="4" width="400" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="4"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
  `;
};

export const stop = (type, color, status) => {
  if (type === "start") {
    return `
      <svg width="35" height="60" viewBox="0 0 32 53" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(4 1)">
          <rect x="7" y="31" width="10" height="10" rx="5" fill="currentColor" fill-opacity=".16"/>
          <g filter="url(#a)">
            <rect x="8" y="32" width="8" height="8" rx="4" fill="currentColor"/>
            <rect x="8.5" y="32.5" width="7" height="7" rx="3.5" stroke="#fff"/>
          </g>
          <path stroke="#fff" stroke-width="1.5" d="M12 0C5.919 0 1 4.919 1 11c0 6.553 6.946 15.589 9.806 19.03a1.56 1.56 0 0 0 2.404 0C16.054 26.589 23 17.553 23 11c0-6.081-4.919-11-11-11Z" fill="currentColor"/>
          <path d="M10.894 16.21v-3.261h2.609v3.26c0 .36.293.653.652.653h1.957a.654.654 0 0 0 .652-.652v-4.566h1.108c.3 0 .444-.371.216-.567l-5.453-4.91a.657.657 0 0 0-.873 0l-5.453 4.91a.325.325 0 0 0 .216.568h1.108v4.565c0 .358.294.652.653.652h1.956a.654.654 0 0 0 .652-.652Z" fill="#fff"/>
        </g>
        <defs>
          <filter id="a" x="0" y="28" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="4"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
            <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
          </filter>
        </defs>
      </svg>
    `.replace(/currentColor/g, color);
  }

  if (type === "end") {
    return `
      <svg width="35" height="60" viewBox="0 0 32 53" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(4 1)">
          <rect x="7" y="31" width="10" height="10" rx="5" fill="currentColor" fill-opacity=".16"/>
          <g filter="url(#a)">
            <rect x="8" y="32" width="8" height="8" rx="4" fill="currentColor"/>
            <rect x="8.5" y="32.5" width="7" height="7" rx="3.5" stroke="#fff"/>
          </g>
          <path stroke="#fff" stroke-width="1.5" d="M12 0C5.919 0 1 4.919 1 11c0 6.553 6.946 15.589 9.806 19.03a1.56 1.56 0 0 0 2.404 0C16.054 26.589 23 17.553 23 11c0-6.081-4.919-11-11-11Z" fill="currentColor"/>
          <path d="m14.067 8.333-.16-.8A.665.665 0 0 0 13.253 7H8.467c-.367 0-.667.3-.667.667v10c0 .366.3.666.667.666.366 0 .666-.3.666-.666v-4h3.734l.16.8c.06.313.333.533.653.533h3.453c.367 0 .667-.3.667-.667V9c0-.367-.3-.667-.667-.667h-3.066Z" fill="#fff"/>
        </g>
        <defs>
          <filter id="a" x="0" y="28" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="4"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
            <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
          </filter>
        </defs>
      </svg>
    `.replace(/currentColor/g, color);
  }

  return `
    <svg width="52" height="76" viewBox="0 0 26 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(0 1)">
        <rect x="8" y="37" width="10" height="10" rx="5" fill="currentColor" fill-opacity=".16"/>
        <g filter="url(#a)">
          <rect x="9" y="38" width="8" height="8" rx="4" fill="currentColor"/>
          <rect x="9.5" y="38.5" width="7" height="7" rx="3.5" stroke="#fff"/>
        </g>
        <path stroke-width="1.5" stroke="#fff" d="M13 0C5.813 0 0 5.813 0 13c0 7.744 8.209 18.423 11.589 22.49a1.844 1.844 0 0 0 2.841 0C17.791 31.423 26 20.744 26 13c0-7.187-5.813-13-13-13Z" fill="currentColor"/>
        <path d="M13 23C7.48 23 3 18.52 3 13S7.48 3 13 3s10 4.48 10 10-4.48 10-10 10Z" fill="${
          status === "finished" ? "currentColor" : "#fff"
        }" ${status === "finished" ? 'stroke="white" stroke-width="1.5"' : ""}/>
      </g>
      <defs>
        <filter id="a" x="1" y="34" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="4"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
  `.replace(/currentColor/g, color);
};

export const stopEdit = color => {
  return `
      <svg width="36" height="66" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="13" y="45" width="10" height="10" rx="5" fill="currentColor" fill-opacity=".16"/>
        <g filter="url(#a)">
          <rect x="14" y="46" width="8" height="8" rx="4" fill="currentColor"/>
          <rect x="14.5" y="46.5" width="7" height="7" rx="3.5" stroke="#fff"/>
        </g>
        <g filter="url(#b)">
          <mask id="c" fill="#fff">
            <path d="M18 2C9.707 2 3 8.707 3 17c0 8.936 9.471 21.257 13.371 25.95a2.127 2.127 0 0 0 3.279 0C23.529 38.257 33 25.936 33 17c0-8.293-6.707-15-15-15Z"/>
          </mask>
          <path d="M18 2C9.707 2 3 8.707 3 17c0 8.936 9.471 21.257 13.371 25.95a2.127 2.127 0 0 0 3.279 0C23.529 38.257 33 25.936 33 17c0-8.293-6.707-15-15-15Z" fill="#fff"/>
          <path d="m16.371 42.95-1.538 1.278.002.002 1.536-1.28Zm3.279 0 1.537 1.28.005-.006-1.542-1.274ZM18 0C8.603 0 1 7.603 1 17h4C5 9.812 10.812 4 18 4V0ZM1 17c0 5.047 2.625 10.764 5.506 15.591 2.93 4.91 6.345 9.252 8.327 11.637l3.077-2.556C15.992 39.364 12.72 35.2 9.94 30.54 7.112 25.801 5 20.889 5 17H1Zm13.835 27.23a4.127 4.127 0 0 0 6.351 0l-3.072-2.56a.142.142 0 0 1-.05.04.128.128 0 0 1-.053.011.128.128 0 0 1-.053-.01.14.14 0 0 1-.05-.041l-3.073 2.56Zm6.357-.006c1.968-2.382 5.378-6.725 8.305-11.634C32.376 27.763 35 22.047 35 17h-4c0 3.889-2.111 8.8-4.938 13.542-2.778 4.659-6.044 8.823-7.954 11.134l3.084 2.548ZM35 17c0-9.397-7.603-17-17-17v4c7.188 0 13 5.812 13 13h4Z" fill="currentColor" mask="url(#c)"/>
        </g>
        <defs>
          <filter id="a" x="6" y="42" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="4"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
            <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
          </filter>
          <filter id="b" x="0" y="0" width="36" height="47.721" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="1"/>
            <feGaussianBlur stdDeviation="1.5"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
          </filter>
        </defs>
      </svg>`.replace(/currentColor/g, color);
};

export const driver = color => {
  return `
    <svg width="40" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 56c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 54a2 2 0 1 0 .09-3.998A2 2 0 0 0 20 54Z" fill="#fff"/>
      <path d="M20.444 44.803a.435.435 0 0 1-.435.414.437.437 0 0 1-.453-.414c-.126-2.755-1.526-4.537-4.201-5.346C6.548 37.364 0 29.447 0 20 0 8.954 8.954 0 20 0s20 8.954 20 20c0 9.446-6.548 17.364-15.355 19.457-2.675.81-4.075 2.592-4.2 5.346h-.002Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25 16h3l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3h-6c0 1.66-1.34 3-3 3s-3-1.34-3-3H9V14c0-1.1.9-2 2-2h14v4Zm-12 9c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1Zm14.5-7.5 1.96 2.5H25v-2.5h2.5ZM25 25c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1Z" fill="#fff"/>
    </svg>
  `.replace(/currentColor/g, color);
};

export const parking = () => {
  return `
    <svg width="30" height="51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#fff" d="M4 1h22v22H4z"/>
      <path d="M14.787 7.824c-.609 0-1.01.059-1.242.118v3.907c.264.059.575.078 1.006.078 1.59 0 2.572-.806 2.572-2.16 0-1.217-.844-1.943-2.336-1.943Z" fill="#1329FE"/>
      <path d="M23.892 0H6.107a2.843 2.843 0 0 0-2.843 2.843v18.315A2.843 2.843 0 0 0 6.107 24h17.785a2.842 2.842 0 0 0 2.843-2.842V2.843A2.842 2.842 0 0 0 23.892 0Zm1.091 20.702c0 .855-.692 1.546-1.546 1.546H6.53a1.547 1.547 0 0 1-1.547-1.546V3.332c0-.854.692-1.547 1.547-1.547h16.906c.855 0 1.547.693 1.547 1.547v17.37Z" fill="#1329FE"/>
      <path d="M23.435 2.876H6.53a.456.456 0 0 0-.457.456v17.37c0 .25.204.456.457.456h16.906a.457.457 0 0 0 .456-.456V3.332a.456.456 0 0 0-.456-.456Zm-4.561 9.955c-1.02.961-2.537 1.393-4.304 1.393-.393 0-.728-.02-1.026-.059v4.744h-2.942V5.841c.925-.157 2.212-.275 4.038-.275 1.846 0 3.158.353 4.042 1.06.844.667 1.412 1.767 1.412 3.063 0 1.297-.433 2.396-1.22 3.142ZM11 24h8l-4 4-.667-.571L11 24Z" fill="#1329FE"/>
      <g filter="url(#a)">
        <circle cx="15" cy="32" r="3" fill="#fff"/>
        <circle cx="15" cy="32" r="2.25" stroke="#1329FE" stroke-width="1.5"/>
      </g>
      <defs>
        <filter id="a" x="0" y="21" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="6"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"/>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
  `;
};
